import React from 'react';
import {Route, Routes} from "react-router-dom";
import {routes} from "../router/routes";
import Home from "../pages/common/Home";
import Error from "../pages/common/Error";
import Settings from "../pages/common/Settings";
import RepairWork from "../pages/common/RepairWork";

const AppRouter = ({stage, setStage, profile, isUpMe,domainName}) => {
    return (<Routes>
        <Route
            element={<Home isUpMe={isUpMe} domainName={domainName}/>}
            path="/home"
            errorElement={<Error/>}
        />
        <Route
            element={<Home isUpMe={isUpMe} domainName={domainName}/>}
            path=""
            errorElement={<Error/>}
        />
        <Route
            element={<Settings stage={stage} setStage={setStage} profile={profile}/>}
            path="/settings"
            errorElement={<Error/>}
        />
        <Route
            element={<RepairWork/>}
            path="/repair-work/:page"
            errorElement={<Error/>}
        />
        <Route
            element={<RepairWork/>}
            path="/repair-work"
            errorElement={<Error/>}
        />
        {routes.map(route => <Route
            key={route.path}
            element={route.component}
            path={"" + route.path}
            errorElement={route.errorElement}
        />)}
    </Routes>);
};

export default AppRouter;